"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * New Api\'s for all actions
 * Actions APIs
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: ggrigorian@tivo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreviewKernelType = void 0;
/**
 * Type of previewKernel
 * @export
 * @enum {string}
 */
exports.PreviewKernelType = {
    PreviewKernel: 'previewKernel',
    OfferPreviewKernel: 'offerPreviewKernel',
    ContentPreviewKernel: 'contentPreviewKernel',
    RecordingPreviewKernel: 'recordingPreviewKernel',
    UnifiedCollectionPreviewKernel: 'unifiedCollectionPreviewKernel',
    UnifiedCollectionAndOnePassOptionsPreviewKernel: 'unifiedCollectionAndOnePassOptionsPreviewKernel',
    OnePassOptionsPreviewKernel: 'onePassOptionsPreviewKernel',
    RecordingOptionsPreviewKernel: 'recordingOptionsPreviewKernel',
    VodOfferPreviewKernel: 'vodOfferPreviewKernel'
};
